export const Accessibilitytypes = {
    GET_ALLPROJECTS: "GET_ALLPROJECTS",
    GET_ALLDEVELOPERS: "GET_ALLDEVELOPERS",
    GET_ALLTIMEZONES: "GET_ALLTIMEZONES",
    GET_ALLAPPS: "GET_ALLAPPS",
    POST_ALLAPPS: "POST_ALLAPPS",
    UPDATE_APPDATA: "UPDATE_APPDATA",
}
